import { z } from 'zod';

export const TransitGenerateReportDataSchema = z.object({
  transitId: z.string().length(24, 'Invalid id'),
});
export type TransitGenerateReportData = z.infer<typeof TransitGenerateReportDataSchema>;
